/**
 * Created by smizrahi on 7/26/16.
 */

import Logger from '../../utils/Logger'
import EQError from '../../utils/EQError'

import Config from '../config/Config'
import ConfigGps from '../config/ConfigGps'
import ConfigScenario from '../config/ConfigScenario'
import ConfigStepPause from '../config/ConfigStepPause'
import ConfigStepMscore from '../config/ConfigStepMscore'
import * as ConfigStepPauseConst from '../config/ConfigStepPause'


// Global config
const CAMPAIGN_ID = 'campaignid';
const PORTAL_URL = 'portalurl';
const GROUP_ID = 'groupid';
const CONF_VERSION = 'version';
const REFRESH_INTERVAL = 'interval';
const GLOBAL_GPS = 'gps';
const GLOBAL_GPS_ENABLED = 'enable';
const GLOBAL_GPS_GEOCODING = 'geocoding';
const GLOBAL_GPS_GEOCODING_ENABLED = 'enable';

// Chained test
const CHAINED_TESTS = 'chainedtests';
const CHAINED_TESTS_OCM = 'ocm';
const CHAINED_TESTS_OCM_ITEM = 'chainedtest';
const CHAINED_TESTS_OCM_ITEM_ITERATION = 'iteration';
const CHAINED_TESTS_OCM_ITEM_LABEL = 'label';
const CHAINED_TESTS_OCM_ITEM_GPS = 'gps';
const CHAINED_TESTS_OCM_ITEM_GPS_ENABLED = 'enable';
const CHAINED_TESTS_OCM_ITEM_GPS_SEARCHTIME = 'searchtime';
const CHAINED_TESTS_OCM_ITEM_GPS_ACCURACY = 'accuracy';
const CHAINED_TESTS_OCM_ITEM_STEPS = 'steps';

// Pause step
const SCENARIO_STEP_PAUSE = 'pause';
const SCENARIO_STEP_PAUSE_PERIOD = 'period';

// mScore step
const SCENARIO_STEP_SHOOTER = 'shooterstep';
const SCENARIO_STEP_SCORING = 'scoringstep';
const SCENARIO_STEP_MSCORE_INFO_URL = 'url';
const SCENARIO_STEP_MSCORE_INFO_MODULE = 'module';
const SCENARIO_STEP_MSCORE_PARAMS_KEY = 'key';

export default class ConfigParser {

    constructor() {

    }

    /**
     * Parse the configuration from JS object
     *
     * @param configurationJs
     * @returns {Promise} An array of parameters if success, an error if failed
     */
    parse(configurationJs) {
        return new Promise((resolve, reject) => {
            if (configurationJs && configurationJs != '') {
                Logger.log('Parsing configuration');

                const configParsed = configurationJs.response.configuration[0];

                // Campaign Id
                const campaignId = configParsed.attr[CAMPAIGN_ID];

                // Group id
                const groupId = configParsed.attr[GROUP_ID];

                // Conf version
                const confVersion = configParsed.attr[CONF_VERSION];

                // Refresh config interval
                const refreshConfigInterval = configParsed.attr[REFRESH_INTERVAL];

                // Portal url
                const portalUrl = configParsed.attr[PORTAL_URL];

                // Global GPS
                let globalGpsConfig = null;
                if (configParsed[GLOBAL_GPS]) {
                    let globalGpsEnabled = configParsed[GLOBAL_GPS][0].attr[GLOBAL_GPS_ENABLED];
                    // Reverse geocoding
                    let globalGeocodingEnabled = null;
                    if (configParsed[GLOBAL_GPS][0][GLOBAL_GPS_GEOCODING]) {
                        globalGeocodingEnabled = configParsed[GLOBAL_GPS][0][GLOBAL_GPS_GEOCODING][0].attr[GLOBAL_GPS_GEOCODING_ENABLED];
                    }

                    globalGpsConfig = new ConfigGps(globalGpsEnabled, globalGeocodingEnabled);
                }


                // Picking needed scenarios depending on chained test configuration
                let chainedTestsScenarios = new Array();
                if (configParsed[CHAINED_TESTS]) {
                    if (configParsed[CHAINED_TESTS][0][CHAINED_TESTS_OCM]) {
                        const rootChainedTest = configParsed[CHAINED_TESTS][0][CHAINED_TESTS_OCM][0];

                        if (rootChainedTest) {
                            let chainedTestId = 0;
                            rootChainedTest.child.forEach(function (chainedTestItem) {
                                if (chainedTestItem['#name'] == CHAINED_TESTS_OCM_ITEM) {
                                    const chainedTestIterations = chainedTestItem.attr[CHAINED_TESTS_OCM_ITEM_ITERATION];

                                    // EWA-30 : Aggregate GPS Configuration enabled
                                    let scenarioGpsConfigEnabled = false;
                                    if (globalGpsConfig.enabled) {
                                        let scenarioGpsConfigEnabledItem = chainedTestItem[CHAINED_TESTS_OCM_ITEM_GPS][0].attr[CHAINED_TESTS_OCM_ITEM_GPS_ENABLED];
                                        if(typeof(scenarioGpsConfigEnabledItem) !== "boolean") { // Convert as boolean
                                            scenarioGpsConfigEnabledItem = (scenarioGpsConfigEnabledItem === 'true');
                                        }
                                        if (scenarioGpsConfigEnabledItem) scenarioGpsConfigEnabled = true;
                                    }

                                    const chainedTestGpsConfig = new ConfigGps(
                                        scenarioGpsConfigEnabled,
                                        globalGpsConfig.geocodingEnabled,
                                        chainedTestItem[CHAINED_TESTS_OCM_ITEM_GPS][0].attr[CHAINED_TESTS_OCM_ITEM_GPS_SEARCHTIME],
                                        chainedTestItem[CHAINED_TESTS_OCM_ITEM_GPS][0].attr[CHAINED_TESTS_OCM_ITEM_GPS_ACCURACY]
                                    );

                                    let chainedTestLabel = null;
                                    if (chainedTestItem[CHAINED_TESTS_OCM_ITEM_LABEL][0]) {
                                        chainedTestLabel = chainedTestItem[CHAINED_TESTS_OCM_ITEM_LABEL][0];
                                    }

                                    // Steps
                                    let steps = new Array();
                                    let skipNextStep = false;
                                    const chainedTest = chainedTestItem[CHAINED_TESTS_OCM_ITEM_STEPS][0];
                                    if (chainedTest) {
                                        chainedTest.child.forEach(function (step) {
                                            let supportedStep = false;

                                            // Pause step
                                            // BR : Iteration pause is put at the end and should never been skipped !
                                            if (step['#name'] == SCENARIO_STEP_PAUSE && (!skipNextStep || (step == chainedTest.child[(chainedTest.child.length - 1)]))) {
                                                steps.push(new ConfigStepPause(step.attr[SCENARIO_STEP_PAUSE_PERIOD]));
                                                supportedStep = true;
                                            }

                                            // mScore step
                                            if (step['#name'] === SCENARIO_STEP_SHOOTER || step['#name'] === SCENARIO_STEP_SCORING) {
                                                let mScoreModule = null;

                                                if (step.attr && step.attr[SCENARIO_STEP_MSCORE_INFO_MODULE]) {
                                                    mScoreModule = step.attr[SCENARIO_STEP_MSCORE_INFO_MODULE];
                                                }

                                                // Parsing mScore urls
                                                let servers = [];

                                                step.mscoreservers[0].mscoreserver.forEach(function (mScoreServer) {
                                                    servers.push(mScoreServer.attr[SCENARIO_STEP_MSCORE_INFO_URL]);
                                                });

                                                let params = {};
                                                // Parsing mScore parameters
                                                step.parameter.forEach(function (mScoreParam) {
                                                    params[mScoreParam.attr[SCENARIO_STEP_MSCORE_PARAMS_KEY]] = mScoreParam.val;
                                                });

                                                steps.push(new ConfigStepMscore(
                                                    servers,
                                                    params,
                                                    mScoreModule,
                                                    portalUrl
                                                ));
                                                supportedStep = true;
                                            }

                                            // BR : If step is not supported or not the last step, we have to remove the next pause step
                                            skipNextStep = (!supportedStep) ? true : false;
                                        });
                                    }

                                    // BR : If the last step and step just before are a pause, delete this step
                                    if (steps.length > 1) {
                                        const lastStep = steps[(steps.length - 1)];
                                        if ((lastStep.type == ConfigStepPauseConst.STEP_PAUSE_TYPE) && (steps[(steps.length - 2)].type == ConfigStepPauseConst.STEP_PAUSE_TYPE)) {
                                            steps.splice((steps.length - 2), 1);
                                        }

                                        // BR : If only one iteration and last step is a pause, delete the last step
                                        if ((chainedTestIterations == 1) && (lastStep.type == ConfigStepPauseConst.STEP_PAUSE_TYPE)) {
                                            steps.pop();
                                        }
                                    }

                                    // BR : If the first step is a pause, removed it
                                    if (steps.length > 0) {
                                        if (steps[0].type == ConfigStepPauseConst.STEP_PAUSE_TYPE) {
                                            steps.splice(0, 1);
                                        }
                                    }

                                    // BR : If no steps in the script, don't add the scenario
                                    if (steps.length > 0) {
                                        chainedTestsScenarios.push(new ConfigScenario(
                                            steps,
                                            chainedTestGpsConfig,
                                            chainedTestId,
                                            chainedTestLabel,
                                            chainedTestIterations
                                        ));
                                    }
                                }
                                chainedTestId++;
                            });
                        }
                    }
                }

                const config = new Config(campaignId, confVersion, refreshConfigInterval, globalGpsConfig, chainedTestsScenarios, groupId);
                resolve(config);
            } else {
                reject(new EQError('Empty configuration downloaded', 1100));
            }
        });
    }
}



// WEBPACK FOOTER //
// ./js/core/configuration/parser/ConfigParser.js